import { render } from "./Terminais.vue?vue&type=template&id=1cd71441&scoped=true"
import script from "./Terminais.vue?vue&type=script&lang=js"
export * from "./Terminais.vue?vue&type=script&lang=js"

import "./Terminais.vue?vue&type=style&index=0&id=1cd71441&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd71441"]])

export default __exports__